import * as React from 'react';
import classnames from 'classnames';
import * as styles from './Social.module.scss';
import links, { SocialLinkType } from './links';

export type SocialProps = {
    classes?: Partial<typeof styles>;
    exclude?: ReadonlyArray<SocialLinkType>;
    customUrls?: {
        [key in SocialLinkType]?: string;
    };
};

function Social({
    classes,
    exclude = [],
    customUrls,
    children,
}: React.PropsWithChildren<SocialProps>): React.ReactElement {
    return (
        <ul className={classnames(classes?.root, styles.root)}>
            {links.map((item) =>
                exclude.includes(item.type) ? null : (
                    <li key={item.url}>
                        <a
                            href={
                                customUrls && customUrls[item.type]
                                    ? customUrls[item.type]
                                    : item.url
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.link}
                        >
                            {item.icon}
                            <span className="sr-only">{item.type}</span>
                        </a>
                    </li>
                ),
            )}
            {children}
        </ul>
    );
}

export default Social;
